import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'rebass';
import { CgCrop } from 'react-icons/cg';

// Replaces the per-page "Edit story / Change page layout" row once a media
// group is selected — per the design, the selected-state toolbar covers
// those options rather than sitting alongside them. Crop Photo only shows
// when the selection contains a qualifying layer (see canCrop's condition in
// PageSlider.js: a Books::PageImageLayer with kind "user").
const SelectedMediaToolbar = ({ canCrop, onCropPhoto, width }) => (
  <Flex
    // Lets MediaSelectionOverlay's "click outside deselects" guard recognize
    // this toolbar as part of acting ON the current selection (Crop Photo
    // needs it intact) rather than a click away from it.
    data-preserve-selection
    alignItems="center"
    justifyContent="center"
    bg="#2C3E50"
    sx={{ width: width > 0 ? `${width}px` : '100%', maxWidth: '100%', borderRadius: '10px' }}
    px={3}
    py={2}
  >
    <Text fontFamily="Poppins" fontWeight={600} mr={2} fontSize="14px" color="#FFFFFF">
      Item selected
    </Text>
    {canCrop && (
      <Flex onClick={onCropPhoto} alignItems="center" sx={{ gap: '6px', cursor: 'pointer' }}>
        <CgCrop size={20} color="#F97316" />
        <Text fontFamily="Poppins" fontWeight={500} fontSize="14px" color="#FFFFFF">
          Crop Photo
        </Text>
      </Flex>
    )}
  </Flex>
);

SelectedMediaToolbar.propTypes = {
  canCrop: PropTypes.bool,
  onCropPhoto: PropTypes.func.isRequired,
  width: PropTypes.number,
};

SelectedMediaToolbar.defaultProps = {
  canCrop: false,
  width: 0,
};

export default SelectedMediaToolbar;
